import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#ffffff',
        middle: '#272727',
        contrast: '#000000',
        secondary: '#424242',
        accent: '#BDBDBD',
      },
    },
  },
});
